module.exports = __webpack_public_path__ + "aw.no2.832c79bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/aw.no2.jpg
// module id = EHdX
// module chunks = 0